export const NVD_CVE_URL = "https://nvd.nist.gov/vuln/detail/";
export const DOCS_BY_SCANNER_TYPE = {
  nessus: "https://www.tenable.com/plugins/nessus/"
};
export const ID_LABEL_BY_SCANNER_TYPE = {
  qualys: "Qualys ID "
};
const COLUMNS = ["cve", "cvss"];
export const TABLE_LAYOUT = {
  entityTableId: "asset-vulnerabilities",
  defaultPageSize: 20,
  defaultSort: { attributeId: "cvss", direction: "desc" },
  defaultDisplayedAttributes: COLUMNS,
  defaultColumnOrder: COLUMNS
};
